import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';

@Component({

  selector: 'app-report-flowmeter',

  templateUrl: './report-flowmeter.component.html',

  styleUrls: ['./report-flowmeter.component.css']

})

export class ReportFlowmeterComponent implements OnInit {

  lst_Result = [];

  lst_Search = [];

  total_Liter: number = 0

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.mdl_Search.patchValue({

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataZa')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('reportDataTa')!)

    })

    this.search_Result()

  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(val.value) ||

        el.strMobileDomain_strComment?.toString().includes(val.value) ||

        el.strMobileType_strComment?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  async search_Result() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Flowmeter_PeriodicConsumption`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

    this.total_Liter = 0;

    for (const item of this.lst_Result) {

      this.total_Liter += parseFloat(item.fLiter || 0);

    }

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'گزارش مصرف بر اساس فلومتر.xlsx');
  }

}
